import { Form, message, Switch } from 'antd';
import Button from '../../../../../components/Button';
import CurrencyInputPrecision from '../../../Promotion/InputPercentDollar/CurrencyInputPrecision';
import styled from 'styled-components';
import Text from '../../../../../components/Text';
import Box from '../../../../../components/Box';
import { useEffect } from 'react';
import { IGetPackageSmsDashboardResponse } from '../../services/types';
import { AxiosResponse } from 'axios';
import accountApis from '../../../../../services/accountApis';
import { useParams } from 'react-router-dom';
import { getMessageError } from '../../../../../utils/response';

interface IExtendSettingsFormProps {
  data?: IGetPackageSmsDashboardResponse | null;
}

interface IFormValues {
  smsPrice: number;
  voicePrice: number;
  autoApprovedPurchase: boolean;
  autoExtendAmount: boolean;
  amountExtend: number;
}

const ExtendSettingsForm = ({ data }: IExtendSettingsFormProps) => {
  const [form] = Form.useForm<IFormValues>();
  const { shopId } = useParams();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        smsPrice: data.smsPrice,
        voicePrice: data.voicePrice,
        autoApprovedPurchase: data.autoApprovedPurchase,
        autoExtendAmount: data.autoExtendAmount,
        amountExtend: data.amountExtend,
      });
    }
  }, [data]);

  const handleFinish = async (values: IFormValues) => {
    try {
      const response: AxiosResponse<{data: boolean}> = await accountApis.updatePackageSMS(shopId || '', values);

      if (response?.data?.data) {
        message.success('Settings updated successfully');
      }
    } catch (error) {
      message.error(getMessageError(error) || 'Failed to update settings');
      form.setFieldsValue({
        smsPrice: data?.smsPrice,
        voicePrice: data?.voicePrice,
        autoApprovedPurchase: data?.autoApprovedPurchase,
        autoExtendAmount: data?.autoExtendAmount,
        amountExtend: data?.amountExtend,
      });
    }
  };
  return (
    <Container>
      <Form form={form} layout='vertical' className='form-styled' onFinish={handleFinish}>
        <Form.Item label='SMS Cost ($)' name='smsPrice'>
          <CurrencyInputPrecision size='small' decimalLength={4}/>
        </Form.Item>
        <Form.Item label='Voice Cost/Min ($)' name='voicePrice'>
          <CurrencyInputPrecision size='small' decimalLength={4} />
        </Form.Item>
        <Box display='flex' alignItems='center' gap={0.5}>
          <Form.Item name='autoApprovedPurchase'>
            <Switch />
          </Form.Item>
          <Text variant='BODY_1'>Auto Approve Request SMS Purchase</Text>
        </Box>
        <Box display='flex' alignItems='center' gap={0.5}>
          <Form.Item name='autoExtendAmount'>
            <Switch />
          </Form.Item>
          <Text variant='BODY_1' className='auto-extend'>Auto Extend</Text>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) =>
              getFieldValue('autoExtendAmount') && (
                <Form.Item name='amountExtend' noStyle>
                  <CurrencyInputPrecision size='small' />
                </Form.Item>
              )
            }
          </Form.Item>
        </Box>
        <Button variant='SECONDARY' size='small' htmlType='submit'>
          Save
        </Button>
      </Form>
    </Container>
  );
};

export default ExtendSettingsForm;

const Container = styled.div`
  padding: 16px;
  background: #fff;
  border-radius: 8px;

  .form-styled {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .auto-extend {
    white-space: nowrap;
    line-height: 48px;
  }
`;
